// src/stores/preferencesStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Preferencias, Tema } from '@/types';
import { DEFAULT_PREFERENCIAS } from '@/types';

interface PreferencesState {
  preferencias: Preferencias;
  setTema: (tema: Tema) => void;
  setPreferencia: <K extends keyof Preferencias>(key: K, value: Preferencias[K]) => void;
  setPreferencias: (prefs: Partial<Preferencias>) => void;
  resetPreferencias: () => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      preferencias: DEFAULT_PREFERENCIAS,

      setTema: (tema) =>
        set((state) => ({
          preferencias: { ...state.preferencias, tema },
        })),

      setPreferencia: (key, value) =>
        set((state) => ({
          preferencias: { ...state.preferencias, [key]: value },
        })),

      setPreferencias: (prefs) =>
        set((state) => ({
          preferencias: { ...state.preferencias, ...prefs },
        })),

      resetPreferencias: () =>
        set({ preferencias: DEFAULT_PREFERENCIAS }),
    }),
    {
      name: 'qops-preferences',
    }
  )
);
